// The app used to ship a precache service worker generated by
// sw-precache-webpack-plugin (Create React App boilerplate). It served every
// navigation from cache, which meant the runtime configuration injected into
// index.html by docker-entrypoint.sh (DOMAIN, KEYCLOAK_JSON, feature flags)
// could be served stale indefinitely: its precache key is the build-time hash
// of index.html, so redeploying the same build with different env vars did not
// invalidate it.
//
// The service worker is no longer generated, but browsers that already
// installed it keep it forever and would never pick up a new build. This module
// removes it. Keep calling it for a few releases so existing installations are
// cleaned up, then the whole thing can go away.

const PRECACHE_NAME_PREFIX = 'sw-precache-';

export default function unregisterServiceWorker() {
  if (!('serviceWorker' in navigator)) return;

  navigator.serviceWorker.getRegistrations()
    .then(registrations => Promise.all(registrations.map(registration => (
      registration.unregister()
    ))))
    .catch(() => {
      // nothing to unregister, or the browser denied access
    });

  // Unregistering leaves the precached assets (a few MB) in Cache Storage.
  if ('caches' in window) {
    caches.keys()
      .then(names => Promise.all(names
        .filter(name => name.startsWith(PRECACHE_NAME_PREFIX))
        .map(name => caches.delete(name))))
      .catch(() => {
        // Cache Storage unavailable (e.g. private browsing); nothing to do
      });
  }
}
